import { useEffect } from 'react';

import { PATH_TO_VIEW, VIEW_TO_PATH } from '../routes';

// URL → état : synchronise st.view quand l'utilisateur navigue (lien direct, retour/avance du navigateur).
export function useUrlToView({ location, navigate, appState, update }) {
  useEffect(() => {
    const pathView = PATH_TO_VIEW[location.pathname];
    if (pathView) {
      if (pathView !== appState.view) update((s) => ({ ...s, view: pathView }));
    } else {
      // Chemin racine ou inconnu : on redirige vers la dernière page connue (déjà résolue dans st.view).
      navigate(VIEW_TO_PATH[appState.view] || VIEW_TO_PATH.timeline, { replace: true });
    }
  }, [location.pathname]);
}
